// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"218":"c09b43e47c8332dc06db","532":"70299dff690a617f2b68","895":"e8d6eb78719528e13956"}[chunkId] + ".js";
};